import { useCallback, useEffect, useState } from "react"

import { Source } from "utils/interfaces"
import { APP_STATUSES, useAppStatusContext } from "utils/AppStatusContext"
import { buildHashIdsQuery } from "utils/helpers"
import { UserAccount } from "utils/UserAccount"
import { httpClient } from "utils/infrastructure/httpClient"
import { FetchQuestionnaireProfilesResponse } from "modules/NewClientSurvey/common/interface"
import { SurveyResultsStorage } from "modules/NewClientSurvey/common/utils/SurveyResultsStorage"

export interface QueryContextProps {
    resultsKey?: string
    url: string
    jsonData: {
        hash_ids: string[]
        public_services_only: boolean
        mode?: string
        include_legal_info?: boolean
    }
    source?: Source
    hash_ids?: string[]
    method?: string
    skipStorage?: boolean
}

export function useQueryContext(
    query?: QueryContextProps
): [{ loading: boolean; response?: FetchQuestionnaireProfilesResponse }, () => void] {
    const [, { push }] = useAppStatusContext()
    const onNetworkError = useCallback(() => {
        setExecuteQuery(false)
        push && push(APP_STATUSES.error)
    }, [push])
    const [loading, setExecuteQuery] = useState(true)
    const [response, setResponse] = useState<FetchQuestionnaireProfilesResponse>()
    useEffect(() => {
        if (!response && query && loading) {
            setExecuteQuery(true)
            const q = {
                hashIds: query.jsonData.hash_ids,
                source: query.source,
                skipStorage: true,
                publicServicesOnly: query.jsonData.public_services_only,
            }
            const data =
                query.resultsKey && SurveyResultsStorage.extraData
                    ? buildHashIdsQuery(q)
                    : query.jsonData
            httpClient
                .post<FetchQuestionnaireProfilesResponse>(query.url, UserAccount.withUserData(data))
                .then((data) => {
                    setExecuteQuery(false)
                    if (!query.skipStorage) {
                        SurveyResultsStorage.storePartial({
                            extraData: data,
                        })
                    }
                    setResponse(data)
                })
                .catch(() => {
                    setExecuteQuery(false)
                    onNetworkError()
                })
        }
    }, [loading, query])
    return [{ loading, response }, () => setExecuteQuery(true)]
}
